import { render, staticRenderFns } from "./BackBtn.vue?vue&type=template&id=5d6a7f74&scoped=true"
import script from "./BackBtn.vue?vue&type=script&lang=js"
export * from "./BackBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6a7f74",
  null
  
)

export default component.exports